import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import isNil from 'lodash/isNil';
import formatNumber from '../../../helpers/formatNumber'


import { IconStar, IconStarInHalves } from '../icons/Icons';

export default function StarRating({
    rating: rawRating,
    reviewCount,
    size,
    shouldShowReviewCount
}) {
    // Prevent bad data from raining on our parade
    let rating = rawRating;
    if (typeof rawRating !== 'number' || rawRating < 0) {
        rating = 0;
    }
    if (rawRating > 5) {
        rating = 5;
    }

    const formattedCount = formatNumber(reviewCount, 0);
    const formattedRating = isNil(rating)
        ? null
        : (Math.round(rating * 10) / 10).toFixed(1);
    const decVal = rating % 1;

    let ratingForStarDisplay = Math.round(rating);

    if (decVal >= 0.25 && decVal <= 0.8) {
        ratingForStarDisplay = rating;
    }

    // If the count is one or more darken up the text of the total
    const hasReviewCount =  reviewCount >= 1 ? 'sarsa-star-rating-has-count' : '';

    let key = 0;
    const stars = [];

    while (ratingForStarDisplay > 0 && stars.length < 5) {
        if (ratingForStarDisplay >= 1) {
            stars.push(<IconStar key={key} className="filled" />);
        }
        else {
            stars.push(<IconStarInHalves key={key} className="filled" />);
        }

        ratingForStarDisplay -= 1;
        key += 1;
    }

    while (stars.length < 5) {
        stars.push(<IconStar key={key} className="unfilled" />);
        key += 1;
    }

    return (
        <div
            data-component="StarRating"
            className={cx('sarsa-star-rating', {
                md: size === 'md',
                lg: size === 'lg'
            })}>
            <div
                className="sarsa-star-rating-stars"
                role="img"
                aria-label={formattedRating
                    ? `${formattedRating} stars`
                    : 'Not enough reviews to show rating'
                }>
                {stars}
            </div>
            {shouldShowReviewCount && !isNil(reviewCount) && (
                <div className={`sarsa-star-rating-stars-review-count ${hasReviewCount}`}>
                    <span aria-hidden="true">
                        ({formattedCount})
                    </span>
                    <span className="rec-sr-only">
                        {`${formattedCount} reviews`}
                    </span>
                </div>
            )}
        </div>
    );
}

StarRating.propTypes = {
    /** The rating to be converted into starts. Can be a float of any precision */
    rating: PropTypes.number,

    /** The total number of reviews to be displayed after the starts */
    reviewCount: PropTypes.number,

    /** Size of the stars/text ... NOT IMPLEMENTED!!!!! */
    size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', 'xxl']),

    /** If true, the review count is shown */
    shouldShowReviewCount: PropTypes.bool
};

StarRating.defaultProps = {
    size: "md",
    shouldShowReviewCount: true
};
